import { render, staticRenderFns } from "./StorageCockpit.vue?vue&type=template&id=7b98460c&scoped=true"
import script from "./StorageCockpit.vue?vue&type=script&lang=js"
export * from "./StorageCockpit.vue?vue&type=script&lang=js"
import style0 from "./StorageCockpit.vue?vue&type=style&index=0&id=7b98460c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b98460c",
  null
  
)

export default component.exports